<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="(formGroup.controls.totaal.value ?? 0) === 0"
                     class="custom-input-150"
                     icon="eye"
                     type="secondary">Specificatie
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="md" title="Specificatie heffingskortingen">
  <snelstart-ui-dialog-body>
    <form [formGroup]="formGroup">
      @for(item of propertyNamesToCheck; track item; let i = $index) {
        @if (getPropertyValue(item) > 0) {
          <div formGroupName="opbouw">
            <div class="row pe-5">
              <div class="col col-1">
                <p>{{ propertyTextMap[item] }}</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  [formControlName]="item"
                  [id]="item"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-3"></div>
            </div>
          </div>
        }
      }
    </form>
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary">
      Afsluiten
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
